export const SLICE = 'ui';

export const PUSH_ROUTE = `${SLICE}/PUSH_ROUTE`;

export const ADD_NOTIFICATION = `${SLICE}/ADD_NOTIFICATION`;
export const CLOSE_NOTIFICATION = `${SLICE}/CLOSE_NOTIFICATION`;

export const START_REQUEST_LOADING = `${SLICE}/START_REQUEST_LOADING`;
export const END_REQUEST_LOADING = `${SLICE}/END_REQUEST_LOADING`;

export const NotificationTypeEnum = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'informational',
});

export const DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
export const DEFAULT_ROUTE_CHANGE_TIMEOUT = 5000;
export interface Notification {
  id: string;
  type: string;
  title: string;
  timeout: number;
}

export interface UIReducerProps {
  notifications: Notification[];
  pendingRequests: Array<string>;
}

export interface UIReducerStateProps {
  [id: string]: UIReducerProps;
}
